// Generated by GitHub Copilot
import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';
import CommandCenterPopup from '../common/CommandCenterPopup';
import greaterThanLogo from '../../assets/images/Greater Than.png';
import gccMaturityAssessment from '../../assets/pdfs/gcc maturity assessment.pptx';
import LoginButton from '../auth/LoginButton';
import { ssoEnabled } from '../../auth/authConfig';
import fedexLogo from '../../assets/images/Logo Picture Fedex Free HD Image Transparent HQ PNG Download _ FreePNGimg.png';
import telstraLogo from '../../assets/images/Telstra new logo transparent PNG - StickPNG.jpg';
import bmsLogo from '../../assets/images/Bristol Myers Squibb (BMS) _ United Kingdom - SciPro.png';
import ecolabLogo from '../../assets/images/Ecolab.jpg';

/**
 * Dropdown content for "Our Offerings".
 * Each section has a label and a two-column list of service links.
 */

const EXECUTIVE_FORUMS_DROPDOWN = {
  description:
    'GCC Executive forums bringing Leaders, Experts and Partners together to share best Practices, explore Trends and shape Strategies for Innovation and Enterprise Value.​',
  items: [
    { label: 'GCC Forums​', slug: 'gcc-forums', url: '/gcc-forums', internal: true },
    { label: "Ecolab's AJ and Troy onstage at SSON", slug: "convergence-ny" ,url:'https://mediaexchange.accenture.com/media/t/1_8iu5b6gy'},
    { label: 'Everest CEO speakernote', slug: 'everest-ceo-speakernote',url:'https://mediaexchange.accenture.com/media/t/1_lwkojwuk' },
  ],
}


const WHY_ACCENTURE_DROPDOWN = {
  description:
    '250+ GCC Clients supported by Accenture’s Scale, AI Platforms, Ecosystem Alliances and ANSR Partnership to Design, Build and Transform GCCs Faster.​', 
  items: [
    { label: 'Why Accenture?', slug: 'why-accenture', url: '/why-accenture', internal: true },
    { label: 'Leader in Everest Group PEAK Matrix® Assessment 2025​', slug: 'everest-peak', url: 'https://www.accenture.com/content/dam/accenture/final/accenture-com/document-3/Accenture-Everest-Group-Global-In-house-Center-GIC-Setup-Capabilities-in-India-Provider-PEAK-Matrix-Assessment-2024.pdf#zoom=40' },
    { label: 'Leader in the 2025 ISG Provider Lens GCC report​', slug: 'isg-provider-lens', url: 'https://www.accenture.com/content/dam/accenture/final/accenture-com/document-3/Accenture-Global-Capability-Center-GCC-Services-2025.pdf#zoom=40' },
  ],
};


const OUR_OFFERINGS_DROPDOWN = {
  description:
    'End-to-end GCC Offerings that Design, Build and continuously Optimize Global Capability Centers to deliver sustained Value across their Lifecycle',
  // Three columns rendered in a 3-col grid, mirroring the GCC Platform dropdown layout.
  columns: [
    [
      {
        label: 'GCC Stage 0',
        slug: 'gcc-stage-0',
        url: 'https://kxdocuments.accenture.com/contribution/7ac72249-9ce7-4ea9-9758-469602f0f856',
        items: [
          { label: 'GCC Strategy & Design', slug: 'gcc-strategy-design' },
          { label: 'GCC Set up or Scale up – BOT', slug: 'gcc-setup-bot' },
          { label: 'GCC Set up or Scale up – ABO', slug: 'gcc-setup-abo' },
          { label: 'GCC Talent Placement', slug: 'gcc-talent-placement' },
          { label: 'GCC Platform', slug: 'gcc-platform-offering' },
          { label: 'GCC Reinvention', slug: 'gcc-reinvention' },
          { label: 'AI for GCC', slug: 'ai-for-gcc', url: 'https://kxdocuments.accenture.com/Contribution/e844826f-9cd2-4cd0-b27b-42abbd9e0403' },
          { label: 'One GCC', slug: 'one-gcc', url: 'https://kxdocuments.accenture.com/contribution/2ec82ed8-f456-4726-a451-2249028e5486' },
          { label: 'AI Native Skilling', slug: 'ai-native-skilling', url: 'https://kxdocuments.accenture.com/Contribution/dbae0163-bfda-4d30-b0a4-58399547ef19' }
        ],
      },
      {
        label: 'GCC Health check',
        slug: 'gcc-health-check',
        internalUrl: '/gcc-health-check',
        items: [],
      },
    ],
    [
      {
        label: 'ANSR Partnership',
        slug: 'ansr-partnership',
        items: [
          {
            label: 'Joint Value Proposition with ANSR',
            slug: 'ansr-joint-value',
            url: 'https://kxdocuments.accenture.com/contribution/fd64fa2d-b216-4acb-8e06-ba239e5bac75',
          },
        ],
      },
    ],
    [
      {
        label: 'Other Forums',
        slug: 'executive-forums',
        items: [
          { label: "FY'26 GCC Pulse Survey", slug: 'pulse-survey', url: 'https://kxdocuments.accenture.com/contribution/67c6bb7e-6f21-4772-b76f-ec8fcc2ec263' },
          { label: 'GCC Forums', slug: 'gcc-forums', url: '/gcc-forums', internal: true },
          { label: "Ecolab's AJ and Troy onstage at SSON", slug: 'ecolab-sson', url: 'https://mediaexchange.accenture.com/media/t/1_8iu5b6gy' },
          { label: 'Everest CEO speakernote', slug: 'everest-ceo-speakernote', url: 'https://mediaexchange.accenture.com/media/t/1_lwkojwuk' },
        ],
      },
    ],
  ],
};

/**
 * Dropdown content for "Insights & Influence".
 */
const INSIGHTS_DROPDOWN = {
  description:
    'A curated collection of insights, leadership Voices and Market Recognition that anchors our credibility and shapes smarter GCC Decisions.',
  sections: [
    {
      label: 'Thought Leadership',
      slug: 'thought-leadership',
      items: [
        { label: 'Rise of GCC as a Reinvention Engine', slug: 'rise-of-gcc' , url:'https://www.accenture.com/us-en/insights/operations/global-capability-centers-reinvention-engines'},
        { label: 'A Strategic Guide: Best Sourcing for GCCs', slug: 'best-sourcing', url:'https://kxdocuments.accenture.com/contribution/5e6644bf-c2b9-49bf-a874-fbe01e511fbe?preview=1&referrer=https://reinventionconsole.accenture.com/digitalbriefcase'},
        { label: 'GCC Doubletake 5 Surprising GCC Trends', slug: 'gcc-doubletake', url:'https://kxdocuments.accenture.com/contribution/cc25c6d2-a9d9-4201-a71d-bba41a8206ec?preview=1&referrer=https://reinventionconsole.accenture.com/digitalbriefcase' },
        { label: 'Talent Reinventors: Delivering value with and for people in the age of AI', slug: 'talent-reinventors', url:'https://www.accenture.com/us-en/insights/consulting/talent-reinventors-delivering-value-people-age-ai' },
        // { label: 'Insight Page', slug: 'insight-page', url: '/insight-page', internal: true },
      ],
    },
    // {
    //   label: 'Market Positioning',
    //   slug: 'market-positioning',
    //   items: [
    //     { label: 'Leader in Everest Group PEAK Matrix® Assessment 2025', slug: 'everest-peak', url:'https://www.accenture.com/content/dam/accenture/final/accenture-com/document-3/Accenture-Everest-Group-Global-In-house-Center-GIC-Setup-Capabilities-in-India-Provider-PEAK-Matrix-Assessment-2024.pdf#zoom=40' },
    //     { label: 'Leader in the 2025 ISG Provider Lens GCC report', slug: 'isg-provider', url:'https://www.accenture.com/content/dam/accenture/final/accenture-com/document-3/Accenture-Global-Capability-Center-GCC-Services-2025.pdf#zoom=40' },
    //   ],
    // },
    // {
    //   label: 'GCC Forum',
    //   slug: 'gcc-forum',
    //   items: [
    //     { label: 'GCC Convergence NY', slug: 'convergence-ny' ,url:'https://kxdocuments.accenture.com/contribution/f694f9d5-f6d8-4db8-a45d-2aef865fe34b?preview=1&referrer=https://reinventionconsole.accenture.com/digitalbriefcase'},
    //     { label: 'GCC Convergence Chicago', slug: 'convergence-chicago',url:'https://kxdocuments.accenture.com/contribution/381655cf-5053-4ed9-912e-27a997d9cf67?preview=1&referrer=https://reinventionconsole.accenture.com/digitalbriefcase' },
    //     //  { label: "FY'26 GCC Pulse Survey", slug: 'pulse-survey', url:'https://kxdocuments.accenture.com/Contribution/67c6bb7e-6f21-4772-b76f-ec8fcc2ec263?preview=1&referrer=https://reinventionconsole.accenture.com/digitalbriefcase' },
    //   ],
    // },
    {
      label: 'Market Research',
      slug: 'market-research',
      items: [
        { label: "FY'26 GCC Pulse Survey", slug: 'pulse-survey', url:'https://kxdocuments.accenture.com/contribution/67c6bb7e-6f21-4772-b76f-ec8fcc2ec263' },
        { label: 'GCC India Exec Summary​', slug: 'gcc-india-exec-summary' },
        { label: 'Industry Origination Dashboards​', slug: 'industry-origination-dashboards', url:'https://app.powerbi.com/groups/me/reports/25b72a87-355d-489a-9349-69da7a5eda3f/45b3d4de264a09affc1a?ctid=e0793d39-0939-496d-b129-198edd916feb&experience=power-bi' },
        { label: 'GCC Origination Engine​', slug: 'gcc-origination-engine', url:'/gcc-origination-engine.html' }
      ],
    }
  ],
};

/**
 * Dropdown content for "Client Stories".
 * Each card has a logo, bold title, description and URL.
 */
const CLIENT_STORIES_DROPDOWN = {
  description:
    'See how Organizations are using GCCs to unlock Talent, Accelerate Transformation and turn operational Capability into Enterprise-wide Value.',
  cards: [
    {
      slug: 'ecolab',
      logo: ecolabLogo,
      logoAlt: 'Ecolab logo',
      title: 'GCC-Led Talent Hub',
      description: 'Ecolab established a GCC-led Talent Hub in India, leveraging Accenture’s expertise to drive recruitment, training and development of tech talent for global operations.',
      conversationUrl: 'https://mediaexchange.accenture.com/media/t/1_kaab8h05',
    },
    {
      slug: 'fedex',
      logo: fedexLogo,
      logoAlt: 'FedEx logo',
      title: 'AI‑Led GCC Transformation',
      description: 'Outcome-first AI + GBS transformation enables centralized, scalable GCCs—driving cost efficiency, debottlenecking, innovation, and enterprise-wide growth​'

    },
    {
      slug: 'telstra',
      logo: telstraLogo,
      logoAlt: 'Telstra logo',
      title: 'Global AI Joint Venture Launch',
      description: 'Telstra and Accenture formed a global AI joint venture to accelerate data transformation, strengthen capabilities and enhance GCC-driven innovation.'

    },
    {
      slug: 'bms',
      logo: bmsLogo,
      logoAlt: 'Bristol Myers Squibb logo',
      title: 'GenAI Content Hub',
      description: 'BMS collaborated with Accenture to build a GenAI-powered content hub in Mumbai, enabling scalable marketing operations and GCC-led innovation.'
    },
  ],
  libraryUrl: 'https://gccclientstories-uat.accenture.com/ClientStories/?access=gcc-portal-2026-Xk9pQr',
};

/**
 * Dropdown content for "GCC Platform".
 */
const GCC_PLATFORM_DROPDOWN = {
  description:
    'Access Practical Tools, Proven Assets and Accelerators that help simplify GCC Design, Activation and Optimization at every stage.',

  sections: [
    {
      label: 'GCC Platform & Assets',
      slug: 'gcc-platform',
      items: [
        { label: 'GCC Navigator', slug: 'gcc-navigator', url: 'https://reinventionconsole.accenture.com/console/explore/asset-details/ZTVjYWE1MjktOTRjNy00MDNhLWFhOWUtN2RiM2FjNmRkODY1/NmY4MDBjMDQtZDBlYS00MTI5LTk5YTUtMTRjZGY4MDAyYTkx' },
        { label: 'GCC Elevate X', slug: 'elevate-x', url: 'https://reinventionconsole.accenture.com/console/explore/asset-details/NmQwZjJkNjAtY2QxNC00NjkyLWJmYjYtZmIzMWU4MDU0YjM4/NjZhYjc3YmEtZWFkZi00NDFiLTljZmQtODE1MDAxNDJiYzE0/S25vd2xlZGdlIEdyYXBo' },
        { label: 'LearnVantage', slug: 'learnvantage', url: 'https://reinventionconsole.accenture.com/ter/overview?indSegmentID=MDliZWI2YzMtMmYzMy00ZDRjLWFkZDctYWE0MjI0M2U0N2U3&Source=S25vd2xlZGdlIEdyYXBo' },
        { label: 'SynOps', slug: 'synops', url: 'https://reinventionconsole.accenture.com/ter/CustomMenu1?indSegmentID=NDc3YmU1MWMtOGE3NS00ZWExLTlmNjQtOGFjZWMzMjQxYjRi&Source=S25vd2xlZGdlIEdyYXBo' },
        { label: 'GenWizard', slug: 'genwizard', url: 'https://reinventionconsole.accenture.com/console/genwizard' },
         { label: 'Command Center', slug: 'gcc-data-lake', url: '' }

      ],
    },
    {
      label: 'Data resources​',
      slug: 'data-resources',
      items: [
       
        { label: 'VIP​', slug: 'vip', url: 'https://web.valueinsightsplatform.accentureanalytics.com/home' },
        { label: 'CDI', slug: 'cdi', url: 'https://cdi.accenture.com/datamarketplace/products/benchmark' },
        {label: 'Everest Group Research portal', slug: 'everest-group-research-portal', url: 'https://www.everestgrp.com/?s='},
       { label: 'Industry Origination Dashboards​', slug: 'industry-origination-dashboards', url:'https://app.powerbi.com/groups/me/reports/25b72a87-355d-489a-9349-69da7a5eda3f/45b3d4de264a09affc1a?ctid=e0793d39-0939-496d-b129-198edd916feb&experience=power-bi' },
       { label: 'GCC Facts and Stats by Industry', slug: 'gcc-facts-and-stats-by-industry', url: 'https://kxdocuments.accenture.com/Contribution/6f17d635-b1db-40a2-9e49-7d0be7ae68d5' },
       { label: 'GCC Facts and Stats by MU', slug: 'gcc-facts-and-stats-by-mu', url: 'https://kxdocuments.accenture.com/Contribution/7227b8b9-ad0a-451e-af37-cef8c8b8b447' }
      ]
    },
      {
      label: 'IOA',
      slug: 'ioa',
      items: [
        { label: 'OM OD Advisor', slug: 'om-od-advisor', url: 'https://reinventionconsole.accenture.com/omod/' },
        { label: 'Intelligent Org Accelerator', slug: 'intelligent-org-accelerator', url: 'https://ioa.accenture.com/ioa/' },
        { label: 'Super charged analytics ', slug: 'super-charged-analytics', url: 'https://kxdocuments.accenture.com/contribution/acc4fded-5e76-4bcc-af2c-f5c4ed8461a8?referrer=https://portal.accenture.com/' }
      ]
    }
  ],
};

/**
 * Dropdown content for "ANSR Partnership".
 */
const ANSR_PARTNERSHIP_DROPDOWN = {
  description:
    "The unrivalled partnership of ANSR and Accenture delivers one GCC model uniting proven setup playbooks, GCC talent access, enterprise transformation, AI expertise, ecosystem partnerships, and scaled reskilling to design, run, scale and reinvent GCCs​​",
  items: [
    { label: 'Joint Value Proposition with ANSR', slug: 'ansr-joint-value' , url:'https://kxdocuments.accenture.com/contribution/fd64fa2d-b216-4acb-8e06-ba239e5bac75'},
  ],
};

/**
 * Triggers a file download by creating a temporary anchor element.
 * @param {string} fileUrl - The resolved asset URL.
 * @param {string} fileName - The suggested download file name.
 */
const triggerDownload = (fileUrl, fileName) => {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = fileName;
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const NAV_ITEMS = [
  { label: 'Client Stories', hasDropdown: true },
  { label: 'Industry Narratives', hasDropdown: false, url: '/industry-narratives', internal: true },
  { label: 'Originate', hasDropdown: false, url: '/gcc-origination-engine.html' },
  { label: 'Insights', hasDropdown: false, url: '/insight-page', internal: true },
  { label: 'Why Accenture​', hasDropdown: false, url: '/why-accenture', internal: true },
  { label: 'Our Offerings', hasDropdown: true },
  { label: 'GCC Platform & Data Resources', hasDropdown: true },


//   { label: 'Executive Forums​', hasDropdown: true },
//  { label: 'Insights', hasDropdown: false, url: '/insight-page', internal: true },
//   { label: 'Why Accenture​', hasDropdown: true },
//   { label: 'ANSR Partnership', hasDropdown: true },
//   { label: 'Our Offerings', hasDropdown: true },
//   { label: 'GCC Platform & Data Resources', hasDropdown: true },
];

/** Shared mega-dropdown wrapper used by all nav items. */
const DropdownPanel = ({ label, children }) => (
  <div className={styles.dropdownPanel} role="region" aria-label={`${label} menu`}>
    <div className={styles.dropdownInner}>{children}</div>
  </div>
);

/** Shared left description panel inside a dropdown. */
const DropdownLeft = ({ title, description }) => (
  <div className={styles.dropdownLeft}>
    <h2 className={styles.dropdownTitle}>{title}</h2>
    <p className={styles.dropdownDesc}>{description}</p>
  </div>
);

/**
 * Top-level navigation bar for GCC Studio.
 * Fully keyboard-accessible: all interactive elements are focusable with
 * visible focus indicators. Uses semantic <nav> and <ul> for screen readers.
 * Each nav item opens a mega-dropdown panel on click.
 */
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [showCommandCenter, setShowCommandCenter] = useState(false);
  const navRef = useRef(null);

  // Close dropdown when clicking outside the nav
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (label) => {
    setActiveDropdown((prev) => (prev === label ? null : label));
  };

  const closeDropdown = () => setActiveDropdown(null);

  return (
    <nav ref={navRef} className={styles.navbar} role="navigation" aria-label="Main navigation">
      {/* Logo */}
      <div className={styles.logoWrapper}>
        <Link to="/" className={styles.logoInner} aria-label="GCC Studio home">
          <img
            src={greaterThanLogo}
            alt="Accenture GCC Studio logo"
            width="28"
            height="28"
            style={{ objectFit: 'contain' }}
          />
          <span className={styles.logoText}>GCC Studio</span>
        </Link>
        <div className={styles.logoSeparator} aria-hidden="true" />
      </div>

      {/* Desktop Nav Links */}
      <ul className={styles.navList}>
        {NAV_ITEMS.map((item) => {
          const isOpen = activeDropdown === item.label;
          return (
             <li key={item.label} className={styles.navItem}>
              {!item.hasDropdown && item.internal ? (
                <Link
                  to={item.url}
                  className={styles.navButton}
                  onClick={closeDropdown}
                >
                  {item.label}
                </Link>
              ) : !item.hasDropdown && item.url ? (
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.navButton}
                  aria-label={`${item.label} (opens in a new tab)`}
                >
                  {item.label}
                </a>
              ) : (
                <button
                  type="button"
                  className={`${styles.navButton} ${isOpen ? styles.active : ''}`}
                  aria-haspopup="true"
                  aria-expanded={isOpen}
                  onClick={() => item.hasDropdown && toggleDropdown(item.label)}
                >
                  {item.label}
                  <svg
                    className={`${styles.navChevron} ${isOpen ? styles.rotated : ''}`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              )}
            </li>
          );
        })}
      </ul>

      {/* Right Actions */}
      <div className={styles.rightActions}>
        {/* SSO Login / User pill — only when SSO is enabled */}
        {ssoEnabled && <LoginButton />}
        {/* Notification Bell */}
        {/* <button type="button" className={styles.iconButton} aria-label="View notifications">
          <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8}
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        </button> */}

        {/* User Avatar */}
        {/* <button type="button" className={styles.avatarButton} aria-label="Open user profile menu">
          <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
          </svg>
        </button> */}

        {/* Mobile hamburger */}
        <button
          type="button"
          className={styles.hamburgerButton}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <svg style={{ width: '1.25rem', height: '1.25rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* ── Our Offerings Mega Dropdown ── */}
      {activeDropdown === 'Our Offerings' && (
        <DropdownPanel label="Our Offerings">
          <DropdownLeft title="Our Offerings" description={OUR_OFFERINGS_DROPDOWN.description} />
          <div className={styles.dropdownRight}>
            <div className={styles.threeColGrid}>
              {OUR_OFFERINGS_DROPDOWN.columns.map((column, colIdx) => (
                <div key={colIdx}>
                  {column.map((section) => (
                    <div key={section.slug} style={{ marginBottom: '1.5rem' }}>
                      {section.url ? (
                        <a
                          href={section.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.sectionLabel}
                          style={{ textDecoration: 'underline', cursor: 'pointer', display: 'block' }}
                        >
                          {section.label}
                        </a>
                      ) : section.internalUrl ? (
                        <Link
                          to={section.internalUrl}
                          className={styles.sectionLabel}
                          style={{ textDecoration: 'underline', cursor: 'pointer', display: 'block' }}
                          onClick={closeDropdown}
                        >
                          {section.label}
                        </Link>
                      ) : (
                        <p className={styles.sectionLabelPlain}>{section.label}</p>
                      )}
                      {section.items.length > 0 && (
                        <ul className={styles.itemList}>
                          {section.items.map((item) => (
                            <li key={item.slug}>
                              {item.url && item.internal ? (
                                <Link to={item.url} className={styles.dropdownItemBtnTop} onClick={closeDropdown} style={{ textDecoration: 'none' }}>
                                  <span className={styles.arrowTop} aria-hidden="true">→</span>
                                  <span className={styles.sectionLabel} style={{ textDecoration: 'underline' }}>{item.label}</span>
                                </Link>
                              ) : item.url ? (
                                <button type="button" className={styles.dropdownItemBtnTop} onClick={closeDropdown}>
                                  <span className={styles.arrowTop} aria-hidden="true">→</span>
                                  <a
                                    href={item.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.sectionLabel}
                                    style={{ textDecoration: 'underline', marginBottom: 0 }}
                                    aria-label={`${item.label} (opens in a new tab)`}
                                  >
                                    {item.label}
                                  </a>
                                </button>
                              ) : (
                                <div className={styles.dropdownItemBtnTop} style={{ cursor: 'default', pointerEvents: 'none' }}>
                                  <span className={styles.arrowTop} aria-hidden="true">→</span>
                                  <span>{item.label}</span>
                                </div>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </DropdownPanel>
      )}

      {/* ── Insights & Influence Mega Dropdown ── */}
      {activeDropdown === 'Insights' && (
        <DropdownPanel label="Insights">
          <DropdownLeft title="Insights" description={INSIGHTS_DROPDOWN.description} />
          <div className={styles.dropdownRight}>
            <div className={styles.threeColGrid}>
              {INSIGHTS_DROPDOWN.sections.slice(0, 2).map((section) => (
                <div key={section.slug}>
                  <p className={styles.sectionLabelPlain}>{section.label}</p>
                  <ul className={styles.itemList}>
                    {section.items.map((item) => (
                      <li key={item.slug}>
                        {item.url && item.internal ? (
                          <Link to={item.url} className={styles.dropdownItemBtnTop} onClick={closeDropdown} style={{ textDecoration: 'none' }}>
                            <span className={styles.arrowTop} aria-hidden="true">→</span>
                            <span className={styles.sectionLabel} style={{ textDecoration: 'underline' }}>{item.label}</span>
                          </Link>
                        ) : item.url ? (
                          <button type="button" className={styles.dropdownItemBtnTop} onClick={closeDropdown}>
                            <span className={styles.arrowTop} aria-hidden="true">→</span>
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.sectionLabel}
                              style={{ textDecoration: 'underline' }}
                              aria-label={`${item.label} (opens in a new tab)`}
                            >
                              {item.label}
                            </a>
                          </button>
                        ) : (
                          <div className={styles.dropdownItemBtnTop} style={{ cursor: 'default', pointerEvents: 'none' }}>
                            <span className={styles.arrowTop} aria-hidden="true">→</span>
                            <span className={styles.sectionLabel}>{item.label}</span>
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
              {/* GCC Forum + Market Research share one column */}
              <div>
                {INSIGHTS_DROPDOWN.sections.slice(2).map((section) => (
                  <div key={section.slug} >
                    <p className={styles.sectionLabelPlain}>{section.label}</p>
                    <ul className={styles.itemList}>
                      {section.items.map((item) => (
                        <li key={item.slug}>
                          {item.url && item.internal ? (
                            <Link to={item.url} className={styles.dropdownItemBtnTop} onClick={closeDropdown} style={{ textDecoration: 'none' }}>
                              <span className={styles.arrowTop} aria-hidden="true">→</span>
                              <span className={styles.sectionLabel} style={{ textDecoration: 'underline' }}>{item.label}</span>
                            </Link>
                          ) : item.url ? (
                            <button type="button" className={styles.dropdownItemBtnTop} onClick={closeDropdown}>
                              <span className={styles.arrowTop} aria-hidden="true">→</span>
                              <a
                                href={item.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.sectionLabel}
                                style={{ textDecoration: 'underline' }}
                                aria-label={`${item.label} (opens in a new tab)`}
                              >
                                {item.label}
                              </a>
                            </button>
                          ) : (
                            <div className={styles.dropdownItemBtnTop} style={{ cursor: 'default', pointerEvents: 'none' }}>
                              <span className={styles.arrowTop} aria-hidden="true">→</span>
                              <span className={styles.sectionLabel} style={{ textDecoration: 'underline' }}>{item.label}</span>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </DropdownPanel>
      )}

      {/* ── Client Stories Mega Dropdown ── */}
      {activeDropdown === 'Client Stories' && (
        <DropdownPanel label="Client Stories">
          <DropdownLeft title="Client Stories" description={CLIENT_STORIES_DROPDOWN.description} />
          <div className={styles.dropdownRight}>
            <ul className={styles.itemList} style={{ gap: '1rem' }}>
              <li>
                <Link
                  to="/client-stories"
                  className={styles.dropdownItemBtnTop}
                  onClick={closeDropdown}
                  style={{ textDecoration: 'none' }}
                >
                 <span className={styles.arrow} aria-hidden="true">→</span>
                  <span className={styles.sectionLabel} style={{ textDecoration: 'underline' }}>
                    Flagship client stories
                  </span>
                </Link>
              </li>
              <li>
                <div className={styles.dropdownItemBtnTop} style={{ cursor: 'default' }}>
                  <span className={styles.arrow} aria-hidden="true">→</span>
                  <span className={styles.sectionLabel} style={{ textDecoration: 'none' }}>
                    For additional relevant GCC client stories, please refer to the{' '}
                     <Link
                      to="/clientstories"
                      className={styles.storyLibraryLink}
                      aria-label="GCC client stories library"
                    >
                      library
                    </Link> 
                    {/* <a
                      href={CLIENT_STORIES_DROPDOWN.libraryUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.storyLibraryLink}
                      aria-label="GCC client stories library (opens in a new tab)"
                    >  library
                    </a> */}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </DropdownPanel>
      )}

      {/* ── GCC Platform Mega Dropdown ── */}
      {activeDropdown === 'GCC Platform & Data Resources' && (
        <DropdownPanel label="GCC Platform & Data Resources">
          <DropdownLeft title="GCC Platform & Data Resources" description={GCC_PLATFORM_DROPDOWN.description} />
          <div className={styles.dropdownRight}>
            <div className={styles.threeColGrid}>
              {GCC_PLATFORM_DROPDOWN.sections.map((section) => (
                <div key={section.slug}>
                  <p className={styles.sectionLabelPlain}>{section.label}</p>
                  <ul className={styles.itemList}>
                    {section.items.map((item) => (
                      <li key={item.slug}>
                        {item.slug === 'gcc-data-lake' ? (
                          <button
                            type="button"
                            className={styles.dropdownItemBtnTop}
                            onClick={() => { closeDropdown(); setShowCommandCenter(true); }}
                          >
                            <span className={styles.arrowTop} aria-hidden="true">→</span>
                            <span className={styles.sectionLabel} style={{ textDecoration: 'underline' }}>{item.label}</span>
                          </button>
                        ) : item.url ? (
                          <button type="button" className={styles.dropdownItemBtnTop} onClick={closeDropdown}>
                            <span className={styles.arrowTop} aria-hidden="true">→</span>
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.sectionLabel}
                              style={{ textDecoration: 'underline' }}
                              aria-label={`${item.label} (opens in a new tab)`}
                            >
                              {item.label}
                            </a>
                          </button>
                        ) : (
                          <div className={styles.dropdownItemBtnTop} style={{ cursor: 'default', pointerEvents: 'none' }}>
                            <span className={styles.arrowTop} aria-hidden="true">→</span>
                            <span>{item.label}</span>
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </DropdownPanel>
      )}

      {/* ── ANSR Partnership Mega Dropdown ── */}
      {activeDropdown === 'ANSR Partnership' && (
        <DropdownPanel label="ANSR Partnership">
          <DropdownLeft title="ANSR Partnership" description={ANSR_PARTNERSHIP_DROPDOWN.description} />
          <div className={styles.dropdownRight}>
            <ul className={styles.itemList}>
              {ANSR_PARTNERSHIP_DROPDOWN.items.map((item) => (
                <li key={item.slug}>
                  <button type="button" className={styles.dropdownItemBtn} onClick={closeDropdown}>
                    <span className={styles.arrow} aria-hidden="true">→</span>
                    {item.url ? (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.sectionLabel}
                        style={{ textDecoration: 'underline' }}
                        aria-label={`${item.label} (opens in a new tab)`}
                      >
                        {item.label}
                      </a>
                    ) : (
                      <p >{item.label}</p>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </DropdownPanel>
      )}

      {/* Additional dropdowns for "Executive forums​" and "Why Accenture​" can be implemented similarly using the DropdownPanel component and corresponding content objects. */}

      {activeDropdown === 'Executive Forums​' && (
        <DropdownPanel label="Executive Forums​">
          <DropdownLeft title="Executive Forums​" description={EXECUTIVE_FORUMS_DROPDOWN.description} />
          <div className={styles.dropdownRight}>
            <ul className={styles.itemList}>
              {EXECUTIVE_FORUMS_DROPDOWN.items.map((item) => (
                <li key={item.slug}>
                  <button type="button" className={styles.dropdownItemBtn} onClick={closeDropdown}>
                    <span className={styles.arrow} aria-hidden="true">→</span>
                    {item.url && item.internal ? (
                      <Link
                        to={item.url}
                        className={styles.sectionLabel}
                        style={{ textDecoration: 'underline' }}
                      >
                        {item.label}
                      </Link>
                    ) : item.url ? (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.sectionLabel}
                        style={{ textDecoration: 'underline' }}
                        aria-label={`${item.label} (opens in a new tab)`}
                      >
                        {item.label}
                      </a>
                    ) : (
                      <p className={styles.sectionLabel}>{item.label}</p>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </DropdownPanel>
      )}
       
      {activeDropdown === 'Why Accenture​' && (
        <DropdownPanel label="Why Accenture​">
          <DropdownLeft title="Why Accenture​" description={WHY_ACCENTURE_DROPDOWN.description} />
          <div className={styles.dropdownRight}>
            <ul className={styles.itemList}>
              {WHY_ACCENTURE_DROPDOWN.items.map((item) => (
                <li key={item.slug}>
                  <button type="button" className={styles.dropdownItemBtn} onClick={closeDropdown}>
                    <span className={styles.arrow} aria-hidden="true">→</span>
                    {item.url && item.internal ? (
                      <Link
                        to={item.url}
                        className={styles.sectionLabel}
                        style={{ textDecoration: 'underline' }}
                      >
                        {item.label}
                      </Link>
                    ) : item.url ? (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.sectionLabel}
                        style={{ textDecoration: 'underline' }}
                        aria-label={`${item.label} (opens in a new tab)`}
                      >
                        {item.label}
                      </a>
                    ) : (
                      <p className={styles.sectionLabel}>{item.label}</p>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </DropdownPanel>
      )}

      {/* ── Industry Narratives Mega Dropdown ── */}
      {activeDropdown === 'Industry Narratives' && (
        <DropdownPanel label="Industry Narratives">
          <DropdownLeft
            title="Industry Narratives"
            description="Explore GCC opportunity narratives across 14 industries — from underpenetrated sectors like Life Sciences and Insurance to mature markets like High Tech and Software & Platforms."
          />
          <div className={styles.dropdownRight}>
            <ul className={styles.itemList}>
              <li>
                <Link
                  to="/industry-narratives"
                  className={styles.dropdownItemBtnTop}
                  onClick={closeDropdown}
                  style={{ textDecoration: 'none' }}
                >
                  <span className={styles.arrow} aria-hidden="true">→</span>
                  <span className={styles.sectionLabel} style={{ textDecoration: 'underline' }}>
                    Explore Industry Narratives
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </DropdownPanel>
      )}

      {/* ── Command Center Popup ── */}
      <CommandCenterPopup
        isOpen={showCommandCenter}
        onClose={() => setShowCommandCenter(false)}
        onReopen={() => setShowCommandCenter(true)}
      />

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className={styles.mobileDropdown}>
          <ul className={styles.mobileList}>
            {NAV_ITEMS.map((item) => (
              <li key={item.label}>
                <button type="button" className={styles.mobileButton} onClick={() => setMenuOpen(false)}>
                  {item.url ? (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.sectionLabel}
                      style={{ textDecoration: 'underline' }}
                      aria-label={`${item.label} (opens in a new tab)`}
                    >
                      {item.label}
                    </a>
                  ) : (
                    <p className={styles.sectionLabel}>{item.label}</p>
                  )}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
